import all from "ramda/es/all";
import append from "ramda/es/append";
import apply from "ramda/es/apply";
import both from "ramda/es/both";
import complement from "ramda/es/complement";
import compose from "ramda/es/compose";
import cond from "ramda/es/cond";
import curry from "ramda/es/curry";
import equals from "ramda/es/equals";
import has from "ramda/es/has";
import ifElse from "ramda/es/ifElse";
import map from "ramda/es/map";
import mergeRight from "ramda/es/mergeRight";
import mergeWith from "ramda/es/mergeWith";
import objOf from "ramda/es/objOf";
import prepend from "ramda/es/prepend";
import reject from "ramda/es/reject";
import type from "ramda/es/type";
import useWith from "ramda/es/useWith";
import values from "ramda/es/values";
import { asyncScheduler } from 'rxjs';
import { buffer, pairwise, take, throttleTime } from 'rxjs/operators';
const isObject = compose(equals('Object'), type);
const allAreObjects = compose(all(isObject), values);
const hasLeft = has('left');
const hasRight = has('right');
const hasBoth = both(hasLeft, hasRight);
const isEqual = both(hasBoth, compose(apply(equals), values));
const markAdded = compose(append(undefined), values);
const markRemoved = compose(prepend(undefined), values);
const isAddition = both(hasLeft, complement(hasRight));
const isRemoval = both(complement(hasLeft), hasRight);
const objectDiff = curry(diff);
// stolen from https://gist.github.com/plukevdh/dec4b41d5b7d67f83be630afecee499e
function diff(l, r) {
    return compose(map(cond([
        [
            isAddition,
            markAdded
        ],
        [
            isRemoval,
            markRemoved
        ],
        [
            hasBoth,
            ifElse(allAreObjects, compose(apply(objectDiff), values), values)
        ]
    ])), reject(isEqual), useWith(mergeWith(mergeRight), [
        map(objOf('left')),
        map(objOf('right'))
    ]))(l, r);
}
const logStateStream = ($, title)=>{
    const sub1 = $.pipe(take(1)).subscribe((first)=>{
        console.groupCollapsed(`${title} INIT`);
        console.log(first);
        console.groupEnd();
    });
    const sub2 = $.pipe(pairwise()).subscribe(([prev, next])=>{
        console.groupCollapsed(`${title} CHANGED`);
        console.log('prev', prev);
        console.log('next', next);
        console.log('diff', objectDiff(prev, next));
        console.groupEnd();
    });
    return {
        unsubscribe: ()=>{
            sub1.unsubscribe();
            sub2.unsubscribe();
        }
    };
};
const logBufferedStream = ($, title)=>$.pipe(buffer($.pipe(throttleTime(1000, asyncScheduler, {
        trailing: true
    })))).subscribe((data)=>{
        console.groupCollapsed(`${title} BUFFER`);
        console.log(data);
        console.groupEnd();
    });
// takovej rychlej a asi ne moc sofistikovandj logger. Chtelo by to potunit
export default ((formStream$)=>{
    const formName = formStream$.name;
    const subFormData = logStateStream(formStream$.formData$, `${formName} - FORM DATA`);
    const subFormFieldState = logStateStream(formStream$.formFieldState$, `${formName} - FORM FIELD STATE`);
    const subFormState = logStateStream(formStream$.formState$, `${formName} - FORM STATE`);
    const subFormDescription = logStateStream(formStream$.formDescriptor$, `${formName} - FORM DESCRIPTOR`);
    const subGlobalErrors = logStateStream(formStream$.globalErrors$, `${formName} - GLOBAL ERRORS`);
    const subControl = logBufferedStream(formStream$.control$, `${formName} - CONTROL`);
    const subTransmission = logBufferedStream(formStream$.transmission$, `${formName} - TRANSMISSION`);
    return {
        unsubscribe: ()=>{
            subFormData.unsubscribe();
            subFormFieldState.unsubscribe();
            subFormState.unsubscribe();
            subFormDescription.unsubscribe();
            subGlobalErrors.unsubscribe();
            subControl.unsubscribe();
            subTransmission.unsubscribe();
        }
    };
});
